import { styled } from '@mui/material/styles';
import VpLink from '../VpLink';

const svgStyles = {
  height: '20px',
  width: '20px'
};

export const StyledVpLink = styled(VpLink, {
  shouldForwardProp: (prop) => prop !== 'color' || prop !== 'backgroundColor' || prop !== 'custom'
})(({ theme, color, backgroundColor, custom }) => ({
  backgroundColor: custom && backgroundColor ? backgroundColor : theme.palette.vpColors.grey,
  borderRadius: '50%',
  padding: '10px',
  boxSizing: 'content-box',
  color: custom && color ? color : theme.palette.vpColors.white,
  ...svgStyles,
  svg: {
    color: custom && color ? color : theme.palette.vpColors.white,
    padding: '0px',
    ...svgStyles
  }
}));



// WEBPACK FOOTER //
// ./src/vp-ui/components/SocialMediaElement/styles.js